const splitCharTitle = () => {
  let title = document.querySelector('.page-title');
  // console.log('title : ', title);

  let titleContent = title.textContent;  
//   'a nice string'.indexOf('nice') !== -1 //true

  const wrapLine = (s, w) => s.replace(
    new RegExp(`(?![^\\n]{1,${w}}$)([^\\n]{1,${w}})\\s`, 'g'), '<span class="line">$1</span>\n'
  );

  let newText = wrapLine(titleContent, '');
//   let divFaker = document.createElement('span')
  let div = document.createElement('div')
  div.innerHTML = newText


    if(newText.indexOf('<span') === -1) {
        let _words = newText.replace(/([^\s]+)/g, '<span class="words">$&</span>');
        let _div = document.createElement('span')
        _div.classList.add('line');
  
        let wordFaker = document.createElement('span')
        wordFaker.innerHTML = _words
        wordFaker.querySelectorAll('.words').forEach((w) => {
            let _chars = w.textContent.replace(/([^\s])/g, '<span class="char">$&</span>');
            w.innerHTML = _chars
            // wordFaker.appendChild(_chars);
            // _div
        });
        div.innerHTML = wordFaker.innerHTML;
    } else {
        div.querySelectorAll('.line').forEach((l) => {
            let _words = l.textContent.replace(/([^\s]+)/g, '<span class="words">$&</span>');
            let _div = document.createElement('span')
            _div.classList.add('line');
      
            let wordFaker = document.createElement('span')
            wordFaker.innerHTML = _words
            wordFaker.querySelectorAll('.words').forEach((w) => {
                let _chars = w.textContent.replace(/([^\s])/g, '<span class="char">$&</span>');
                w.innerHTML = _chars
                // wordFaker.appendChild(_chars);
                // _div
            });
            l.innerHTML = wordFaker.innerHTML;
        });
    }
  title.innerHTML = div.innerHTML;
}

export { splitCharTitle }